import RouteNames from './RouteNames'

const routesSearchParams = {
  [RouteNames.fundraisingEventsThankYou]: '?ids',
  [RouteNames.streambotFundraisingEvents]: '?token',
  [RouteNames.streambotFundraisingEventsTotal]: '?token&subtractCents',
  [RouteNames.streambotFundraisingEventsVoting]: '?token&preview',
  [RouteNames.fundraisingEventsManageProjects]: '?page&query&category&organisation&bounds',
  [RouteNames.organisationsManageCalendar]: '?project_id&pivot',
  [RouteNames.fundraisingEvents]: '?utm_source&utm_medium&utm_campaign&utm_term',
  [RouteNames.fundraisingEventsSharingOptions]: '?utm_campaign&utm_medium',
  [RouteNames.apiMatchingEventsProjects]: '?wirwunderOnly',
} as const

export default routesSearchParams
